class Accordion {
  constructor(element) {
    this.triggerAttr = "[data-accordion-trigger]";
    this.contentAttr = "[data-accordion-content]";
    this.ariaExpandedAttr = "aria-expanded";
    this.openAttr = "data-accordion-open";

    this.accordion = element;
    this.items = this.accordion.querySelectorAll("[data-accordion-item]");
    this.allowMultiple = this.accordion.hasAttribute("data-allow-multiple");

    this.init();
  }

  init() {
    this.items.forEach((item, index) => {
      const trigger = item.querySelector(this.triggerAttr);
      const content = item.querySelector(this.contentAttr);

      if (!trigger || !content) {
        return;
      }

      this.setInitialState(trigger, content);

      trigger._clickHandler = (event) => this.handleClick(event, trigger, content);
      trigger._keydownHandler = (event) => this.handleKeydown(event, index);

      trigger.addEventListener("click", trigger._clickHandler);
      trigger.addEventListener("keydown", trigger._keydownHandler);
    });
  }

  setInitialState(trigger, content) {
    trigger.setAttribute(this.ariaExpandedAttr, "false");
    content.style.height = "0px";
  }

  handleClick(event, trigger, content) {
    event.preventDefault();

    const isExpanded = trigger.getAttribute(this.ariaExpandedAttr) === "true";
    if (!this.allowMultiple) {
      this.closeAllItems();
    }

    if (isExpanded) {
      this.closeItem(trigger, content);
      return;
    }

    this.openItem(trigger, content);
  }

  handleKeydown(event, currentIndex) {
    const triggers = Array.from(this.accordion.querySelectorAll(this.triggerAttr));

    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        triggers[currentIndex === triggers.length - 1 ? 0 : currentIndex + 1].focus();
        break;

      case "ArrowUp":
        event.preventDefault();
        triggers[currentIndex === 0 ? triggers.length - 1 : currentIndex - 1].focus();
        break;

      case "Home":
        event.preventDefault();
        triggers[0].focus();
        break;

      case "End":
        event.preventDefault();
        triggers[triggers.length - 1].focus();
        break;

      case "Enter":
      case " ":
        event.preventDefault();
        triggers[currentIndex].click();
        break;
    }
  }

  openItem(trigger, content) {
    trigger.setAttribute(this.ariaExpandedAttr, "true");
    content.setAttribute(this.openAttr, "");
    content.style.height = content.scrollHeight + "px";

    // Toggle icon to minus
    const plusIcon = trigger.querySelector('[data-icon="plus"]');
    const minusIcon = trigger.querySelector('[data-icon="minus"]');
    if (plusIcon && minusIcon) {
      plusIcon.style.opacity = "0";
      minusIcon.style.opacity = "1";
    }

    // Fade in the border
    setTimeout(() => {
      content.style.opacity = "1";
    }, 25);
  }

  closeItem(trigger, content) {
    trigger.setAttribute(this.ariaExpandedAttr, "false");
    content.removeAttribute(this.openAttr);
    content.style.height = content.scrollHeight + "px";

    // Toggle icon to plus
    const plusIcon = trigger.querySelector('[data-icon="plus"]');
    const minusIcon = trigger.querySelector('[data-icon="minus"]');
    if (plusIcon && minusIcon) {
      plusIcon.style.opacity = "1";
      minusIcon.style.opacity = "0";
    }

    // Fade out the border
    content.style.opacity = "0";

    // Force reflow then animate to 0
    content.offsetHeight;
    content.style.height = "0px";
  }

  closeAllItems() {
    this.items.forEach((item) => {
      const trigger = item.querySelector(this.triggerAttr);
      const content = item.querySelector(this.contentAttr);

      if (!trigger || !content) {
        return;
      }

      const isExpanded = trigger.getAttribute(this.ariaExpandedAttr) === "true";
      if (!isExpanded) {
        return;
      }

      this.closeItem(trigger, content);
    });
  }

  destroy() {
    this.items.forEach((item) => {
      const trigger = item.querySelector(this.triggerAttr);
      if (!trigger) {
        return;
      }

      trigger.removeEventListener("click", trigger._clickHandler);
      trigger.removeEventListener("keydown", trigger._keydownHandler);
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-accordion]").forEach((accordion) => {
    accordion._instance = new Accordion(accordion);
  });

  window.addEventListener("unload", () => {
    document.querySelectorAll("[data-accordion]").forEach((accordion) => {
      if (!accordion._instance) {
        return;
      }

      accordion._instance.destroy();
      delete accordion._instance;
    });
  });
});

document.addEventListener("shopify:section:load", (event) => {
  const accordion = event.target.querySelector("[data-accordion]");
  if (!accordion) {
    return;
  }

  accordion._instance = new Accordion(accordion);
});

document.addEventListener("shopify:section:unload", (event) => {
  const accordion = event.target.querySelector("[data-accordion]");
  if (!accordion || !accordion._instance) {
    return;
  }

  accordion._instance.destroy();
  delete accordion._instance;
});
